const mapping: Record<string, string> = {
  id: 'e=>e.Id',
  name: 'e=>e.Name',
  description: 'e=>e.Description',
}

export const mapSortVerifierDeviceDisabledParam = (key: string) => mapping[key]
